(function() {
  const helpers = function() {
    const $body = document.body;
    const $html = document.querySelector('html');
    const $header = document.querySelector('header');

    const preventBodyScrolling = function() {
      $html.classList.add('locked');
      $header.style.top = '0px';
      $body.style.top = `-${window.scrollY}px`;
      $body.classList.add('locked');
    };

    const restoreBodyScrolling = function() {
      const scrollY = Math.abs(parseInt($body.style.top) || 0);
      $header.style.removeProperty('top');
      $body.style.removeProperty('top');
      $body.classList.remove('locked');
      window.scrollTo({ top: scrollY, behavior: 'instant' });
      $html.classList.remove('locked');
    };

    const debounce = function(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    };

    const sleep = function(ms) { return new Promise(res => setTimeout(res, ms)); };

    const asyncFetch = async function(path) {
      let response;

      try {
        response = await fetch(path);

        if (response.ok) {
          return response.text();
        } else {
          throw Error(response.statusText);
        }
      } catch(error) {
        console.log(`Error: ${error}`);
        return false;
      }
    };

    return {
      preventBodyScrolling,
      restoreBodyScrolling,
      debounce,
      sleep,
      asyncFetch,
    };
  }();

  (function() {
    const $header = document.querySelector('header');
    const $heroLogo = $header.querySelector('.header__logo');
    const $mobileHamburger = $header.querySelector('.hamburger');
    const $headerNav = $header.querySelector('.header__menu');
    const $searchBoxes = $headerNav.querySelectorAll('.menu-search'); // mobile & desktop versions
    const $otherNavButtons = [...$headerNav.querySelectorAll('.header__menu-ul > li > *:first-child')].filter(function(c) { return ![...$searchBoxes].includes(c); });
    const $searchBG = document.querySelector('#header-search-bg');
    const isSearchPage = window.location.pathname.includes('/search');
    const urlSearchParams = (new URL(window.location)).searchParams;

    let searchIsOpen = false;
    let searchInProgressTimeout = 0; // avoid multiple calls of consecutive keyboard inputs
    let searchPageLoaded = false;

    const toggleSearchBar = function() {
      searchIsOpen = !searchIsOpen;

      $mobileHamburger.classList.toggle('hidden');
      $heroLogo.classList.toggle('hidden');
      $otherNavButtons.forEach(function($otherButton) {
        $otherButton.classList.toggle('hidden');
      });
      $searchBG.classList.toggle('active');

      if (searchIsOpen) {
        helpers.preventBodyScrolling();

        if (!isSearchPage) {
          getSearchResults();
        } else {
          if (!searchPageLoaded) {
            searchPageLoaded == true;
          } else {
            getSearchResults();
          }
        }

        $header.classList.add('search-active');
      } else {
        helpers.restoreBodyScrolling();
        $header.classList.remove('search-active');
      }
    };

    const getSearchResults = async function(searchTerm = false, loaderTimeout = false) {
      const isSearchInputEmpty = !!!searchTerm;
      const searchEndpoint = isSearchInputEmpty
        ? `/?section_id=header-empty-search`
        : `/search/suggest?q=${searchTerm}&section_id=header-predictive-search`;

      const shopifySection = isSearchInputEmpty
        ? '#shopify-section-header-empty-search'
        : '#shopify-section-header-predictive-search';

      try {
        //await helpers.sleep(2000);
        const results = await helpers.asyncFetch(searchEndpoint);

        const resultsMarkup = new DOMParser().parseFromString(results, 'text/html')
          .querySelector(shopifySection).innerHTML;

        $searchBoxes.forEach(function($searchBox) {
          $header.classList.remove('searching');
          searchInProgress = true;

          // cancel loader animation if it hasn't started yet
          if (loaderTimeout) {
            clearTimeout(loaderTimeout);
          }

          const $searchResults = $searchBox.querySelector('.menu-search__results');
          $searchResults.innerHTML = resultsMarkup;
        });
      } catch (error) {
        $header.classList.remove('searching');
        console.log(`Error: `, error);
      }
    };

    const handleSearchInputField = function(e) {
      const $this = e.target;
      const searchTerm = $this.value.trim();

      // add slight delay to search loading state,
      // fast connections won't ever see this
      const loaderTimeout = setTimeout(function() {
        $header.classList.add('searching');
      }, 200);

      // sync search input field value between mobile/desktop versions
      $searchBoxes.forEach(function($searchBox) {
        const $searchInputField = $searchBox.querySelector('.menu-search__input-field');
        if ($searchInputField == $this) { return; }

        $searchInputField.value = searchTerm;
      });

      clearTimeout(searchInProgressTimeout);

      if (searchTerm.length) {
        searchInProgressTimeout = setTimeout(function() {
          getSearchResults(searchTerm, loaderTimeout);
        }, 800);
      } else {
        getSearchResults(false, loaderTimeout);
      }
    }

    // search box specific event listeners
    if ($searchBoxes.length) {
      $searchBoxes.forEach(function($searchBox) {
        const $searchButton = $searchBox.querySelector('.menu-icon--search');
        const $searchInputBox = $searchBox.querySelector('.menu-search__input-box');
        const $searchInputField = $searchInputBox.querySelector('.menu-search__input-field');
        const $searchCloseButton = $searchBox.querySelector('.menu-search__cancel');
        const isMobileSearch = $searchBox.dataset.view === 'mobile';

        // search magnifiying glass button
        $searchButton.addEventListener('click', function() {
          const searchTerm =  $searchInputField.value.trim();
          if (searchIsOpen && searchTerm != '') {
            window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;

            return;
          }

          if(!searchIsOpen) {
            toggleSearchBar();
            $searchInputField.focus();
          }
        });

        // if mobile, check if there are secondary search triggering buttons
        if (isMobileSearch) {
          const $altSearchButtons = document.querySelectorAll('.alt-m-search-btn');

          if ($altSearchButtons.length) {
            $altSearchButtons.forEach(function($altSearchButton) {
              $altSearchButton.addEventListener('click', function(e) {
                if(!searchIsOpen) {
                  toggleSearchBar();
                  $searchInputField.focus();
                }
              });
            });
          }
        }

        // close search button
        $searchCloseButton.addEventListener('click', function() {
          toggleSearchBar();
        });

        // handle search input text entry
        $searchInputBox.addEventListener('input', helpers.debounce(handleSearchInputField, 300));
        $searchInputBox.addEventListener('keyup', function(e) {
          if (e.key === 'Enter') {
            const $this = e.target;
            const searchTerm = $this.value.trim();

            window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
          }
        });

        // load search results into dropdown if search page has query
        if(urlSearchParams.has('q')) {
          const searchValue = urlSearchParams.get('q');
          if (!searchValue || searchValue.trim() === '') {
            // if nothing in search, open the search bar (we only want to open one)
            if (window.innerWidth >= 768) {
              if ($searchBox.dataset.view === 'desktop') {
                toggleSearchBar();
              }
            } else {
              if ($searchBox.dataset.view === 'mobile') {
                toggleSearchBar();
              }
            }
          } else {
            $searchInputField.value = searchValue.trim();
          }

          $searchInputField.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }

    // global search related event listeners

    // close when search bg is clicked
    $searchBG.addEventListener('click', function() {
      toggleSearchBar();
    });

    // close when search is open and customer presses on Escape key
    document.addEventListener('keydown', function(e) {
      const keystroke = e.key;

      if (keystroke === 'Escape') {
        if (searchIsOpen) {
          toggleSearchBar()
        }
      }
    });
  })();
})();
